export default __webpack_public_path__ + "static/open-graph-b286d370d10e77c180990f037a15e65d.png";